import i18next from 'i18next';
import { getLanguage } from './settings';
import { LangCodeEnum } from '../../gql/graphql';

export type GenericObject = {
    [key: string]: any;
};

export const getName = (item: any): string => {
    const def = item?.Name || '-';
    if (!item) {
        return def;
    }
    switch (getLanguage()) {
        case LangCodeEnum.En:
            return item?.en_Name ? item.en_Name : item?.en_name ? item?.en_name : def;
        case LangCodeEnum.Sv:
            return item?.sv_Name ? item.sv_Name : item?.sv_name ? item?.sv_name : def;
        case LangCodeEnum.Fi:
            return item?.fi_Name ? item.fi_Name : item?.fi_name ? item?.fi_name : def;
        case LangCodeEnum.No:
            return item?.no_Name ? item.no_Name : item?.no_name ? item?.no_name : def;
        default:
            return def;
    }
};

export const getDescription = (item: any) => {
    const def = item?.Description
        ? item.Description
        : item?.fi_Description
        ? item.fi_Description
        : '-';

    if (!item) {
        return def;
    }
    switch (getLanguage()) {
        case LangCodeEnum.En:
            return item.en_Description
                ? item.en_Description
                : item?.en_description
                ? item?.en_description
                : def;
        case LangCodeEnum.Sv:
            return item.sv_Description
                ? item.sv_Description
                : item?.sv_description
                ? item?.sv_description
                : def;
        case LangCodeEnum.Fi:
            return item.fi_Description
                ? item.fi_Description
                : item?.fi_description
                ? item?.fi_description
                : def;
        case LangCodeEnum.No:
            return item.no_Description
                ? item.no_Description
                : item?.no_description
                ? item?.no_description
                : def;
        default:
            return def;
    }
};

export const getInstruction = (item: any) => {
    const def = item?.Instruction
        ? item.Description
        : item.fi_instruction
        ? item.fi_instruction
        : '-';
    if (!item) {
        return def;
    }
    switch (getLanguage()) {
        case LangCodeEnum.En:
            return item.en_instruction ? item.en_instruction : def;
        case LangCodeEnum.Sv:
            return item.sv_instruction ? item.sv_instruction : def;
        case LangCodeEnum.Fi:
            return item.fi_instruction ? item.fi_instruction : def;
        default:
            return def;
    }
};

export const getIntervalString = (
    recurrentType: String,
    recurrentCycle: Number | String,
    recurrentMeterType: String,
    t: any,
    i18n: any
) => {
    const def = recurrentType + ' ' + recurrentCycle + ' ' + recurrentMeterType;
    switch (getLanguage()) {
        case LangCodeEnum.En:
            let enRecurrentTypeTranslation = i18n.exists(`serviceInterval:${recurrentType}`)
                ? t(`serviceInterval:${recurrentType}`)
                : undefined;

            let enRecurrentMeterTypeTranslation = i18n.exists(
                `serviceInterval:${recurrentMeterType}`
            )
                ? t(`serviceInterval:${recurrentMeterType}`)
                : undefined;

            if (enRecurrentTypeTranslation && enRecurrentMeterTypeTranslation && recurrentCycle) {
                return (
                    enRecurrentTypeTranslation +
                    ' ' +
                    recurrentCycle +
                    ' ' +
                    enRecurrentMeterTypeTranslation
                );
            } else {
                return undefined;
            }
        case LangCodeEnum.Sv:
            let svRecurrentTypeTranslation = i18n.exists(`serviceInterval:${recurrentType}`)
                ? t(`serviceInterval:${recurrentType}`)
                : '';
            let svRecurrentMeterTypeTranslation = i18n.exists(
                `serviceInterval:${recurrentMeterType}`
            )
                ? t(`serviceInterval:${recurrentMeterType}`)
                : '';

            if (svRecurrentTypeTranslation && svRecurrentMeterTypeTranslation && recurrentCycle) {
                return (
                    recurrentCycle +
                    ' ' +
                    svRecurrentTypeTranslation +
                    ' ' +
                    svRecurrentMeterTypeTranslation
                );
            } else {
                return undefined;
            }
        case LangCodeEnum.Fi:
            let fiRecurrentTypeTranslation = i18n.exists(`serviceInterval:${recurrentType}`)
                ? t(`serviceInterval:${recurrentType}`)
                : '';

            let fiRecurrentMeterTypeTranslation = i18n.exists(
                `serviceInterval:${recurrentMeterType}`
            )
                ? t(`serviceInterval:${recurrentMeterType}`)
                : '';

            if (fiRecurrentTypeTranslation && fiRecurrentMeterTypeTranslation && recurrentCycle) {
                return (
                    recurrentCycle +
                    ' ' +
                    fiRecurrentMeterTypeTranslation +
                    ' ' +
                    fiRecurrentTypeTranslation
                );
            } else {
                return undefined;
            }
        default:
            return def;
    }
};
